/* file description */

import React, { useContext, useImperativeHandle, useState, useMemo, useEffect, useRef } from 'react';
import { Button, Table, Empty, Tabs, message, Input } from 'antd';
import type { SpComListType } from '../../index';
import styles from './index.module.less';
import SelectTree from './components/SelectTree';
import { getSampleDraftTreeData, updateBatch, deleteRecord } from './service';
import PicTable from './components/PicTable';
import FeatureTable from './components/FeatureTable';
import MaterialTable from './components/MaterialTable';
import { GetFilterTableSchema } from './../filterTree/effect/GetFilterTableSchema';
import FilterRecordList from './../filterTree/components/FilterRecordList';

const SampleDraftTree: React.FC<SpComListType> = function SampleDraftTree(props) {
  console.log('SampleDraftTree-props', props);
  const { metaConfig = {}, values, onChange, rulesMap = {}, _rowId, _headId, refList } = props;
  const { freeComponentsConfig = {}, taskInfo = {}, index, pageType } = metaConfig;
  const mainModule = freeComponentsConfig && freeComponentsConfig['position-module'];
  const mainRecordValues = JSON.stringify(values && values[mainModule]);
  const [mainRecord, setMainRecord] = useState<any>({});
  const [changeData, setChangeData] = useState<string>('{}');
  const [showTreeData, setShowTreeData] = useState<any>();
  const [currentSelectNode, setCurrentSelectNode] = useState<any>();
  const [activeKey, setActiveKey] = useState<string>();

  const getTreeData = async (data: any) => {
    const isShow = metaConfig?.pageConfig?.pageModuleConfig?.isc_npi_deliverable_of_finished_produc_sample_row_info?.configList?.find((item: any) => item.name === 'demo_type')?.showSource;
    console.log('isShow', isShow);
    const res = await getSampleDraftTreeData(data.cpart_code, isShow ? data.demo_type : '');
    setShowTreeData(res.treeData);
  };

  useMemo(() => {
    const dataSource = mainRecordValues || '{}';
    const newRecordData = JSON.parse(dataSource);
    const newMainRecord = index || index === 0 ? newRecordData[index] : newRecordData;
    setMainRecord(newMainRecord);
    const reField = ['cpart_code'];
    const newData: any = JSON.parse(changeData);
    reField.map((el: string) => {
      newData[el] = newMainRecord[el];
    });
    const newDataSt = JSON.stringify(newData);
    if (newDataSt !== changeData) {
      setChangeData(newDataSt);
      getTreeData(newMainRecord);
    }
  }, [mainRecordValues]);

  const onSelectNodeChange = (data: any, selected: boolean) => {
    if (!selected) {
      setCurrentSelectNode(data);
      setActiveKey(data && data[freeComponentsConfig?.treeRelationField]);
    } else {
      setCurrentSelectNode(undefined);
      setActiveKey(undefined);
    }
  };

  const { filterTableSchema } = GetFilterTableSchema({
    config: freeComponentsConfig,
    schemaTree: taskInfo.relationTree,
    metaConfig,
    values,
    rulesMap,
  });

  return (
    <>
      <div className={styles.title}>
        {freeComponentsConfig?.title}
      </div>
      <div className={styles.content}>
        {showTreeData && (
        <div className={styles.tree_box}>
          <SelectTree
            data={showTreeData}
            onChange={setShowTreeData}
            handleNodeClick={onSelectNodeChange}
            currentSelectNode={currentSelectNode}
          />
        </div>
        )}
        {showTreeData && (
        <div className={styles.table_box}>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab={'图片信息'} key={'1'} forceRender>
              <PicTable
                currentSelectNode={currentSelectNode}
                pageType={pageType}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={'特征信息'} key={'2'} forceRender>
              <FeatureTable
                currentSelectNode={currentSelectNode}
                pageType={pageType}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={'物料清单交付件'} key={'3'} forceRender>
              <MaterialTable
                currentSelectNode={currentSelectNode}
                pageType={pageType}
                taskId={metaConfig?.taskId}
              />
            </Tabs.TabPane>
            {(
              filterTableSchema.map((module: any, i) => {
                return (
                  <Tabs.TabPane tab={module?.props.tab} key={module?.props.key} forceRender>
                    {module.children?.map((m: any, ind: number) => {
                      const allValues = values ? values[module.handle] : [];
                      const value = allValues?.filter((el: any) => !_headId || el[_headId] === mainRecord[_rowId]);
                      return (
                        currentSelectNode?.isMaterial ? <FilterRecordList
                          key={ind}
                          value={value || []}
                          mainRecordValue={mainRecord}
                          showTreeData={showTreeData}
                          filterProps={module.filterProps}
                          activeKey={activeKey}
                          activeData={currentSelectNode}
                          metaConfig={{
                            ...(metaConfig || {}),
                            pageType: currentSelectNode?.isHighlight ? metaConfig?.pageType : 'view',
                          }}
                          _headIdField={_headId}
                          headIdData={mainRecord[_rowId]}
                          refList={refList}
                          onChange={(data: any) => {
                            const oldData = values[module.handle] || [];
                            const newData = oldData?.filter((el: any) => el[_headId] !== mainRecord[_rowId]).concat(data);
                            const newAllData = {
                              ...values,
                              [module.handle]: newData,
                            };
                            onChange && onChange(newAllData);
                          }}
                          {...m.props}
                          tableBaseMode={currentSelectNode?.isHighlight ? m.props?.tableBaseMode : 'view'}
                        /> : null
                      );
                    })}
                  </Tabs.TabPane>
                );
              })
            )}
          </Tabs>
        </div>
        )}
      </div>
      {!showTreeData && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </>
  );
};

export default SampleDraftTree;
